/* wettr Collection — ATC Animation + Badge Pulse */
(function() {
  /* ATC Animation */
  document.addEventListener('submit', function(e) {
    var form = e.target;
    var pf = form.closest('product-form');
    if (!pf) return;
    var grid = form.closest('.custom_collection_grid');
    if (!grid) return;
    e.preventDefault();
    e.stopPropagation();
    var card = form.closest('.card-wrapper') || form.closest('.card');
    var button = form.querySelector('.quick-add__submit');
    if (!button || button.disabled) return;
    var formData = new FormData(form);
    button.disabled = true;
    button.classList.add('loading');
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST', body: formData
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status) return;
      showAddedOverlay(card);
      updateCartCount();
      animateCartIcon();
      refreshCartDrawer();
    })
    .catch(function(err) { console.error('ATC error:', err); })
    .finally(function() { button.disabled = false; button.classList.remove('loading'); });
  }, true);

  function showAddedOverlay(card) {
    if (!card) return;
    var media = card.querySelector('.card__media') || card.querySelector('.card__inner');
    if (!media) return;
    var existing = media.querySelector('.wettr-added-overlay');
    if (existing) existing.remove();
    var overlay = document.createElement('div');
    overlay.className = 'wettr-added-overlay';
    overlay.innerHTML = '<div class="wettr-added-pill"><span class="wettr-added-check">&#10003;</span><span class="wettr-added-text">Added</span></div>';
    media.style.position = 'relative';
    media.appendChild(overlay);
    requestAnimationFrame(function() { overlay.classList.add('wettr-added-overlay--visible'); });
    setTimeout(function() {
      overlay.classList.remove('wettr-added-overlay--visible');
      setTimeout(function() { if (overlay.parentNode) overlay.remove(); }, 300);
    }, 1500);
  }

  function updateCartCount() {
    fetch(window.Shopify.routes.root + 'cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function(el) { el.textContent = cart.item_count; });
      document.querySelectorAll('.cart-count-bubble').forEach(function(el) { if (cart.item_count > 0) el.removeAttribute('hidden'); });
    });
  }

  function animateCartIcon() {
    document.querySelectorAll('.header__icon--cart, a[href="/cart"], .cart-icon-bubble').forEach(function(el) {
      el.classList.add('wettr-cart-bounce');
      setTimeout(function() { el.classList.remove('wettr-cart-bounce'); }, 600);
    });
  }

  function refreshCartDrawer() {
    Promise.all([
      fetch('/?section_id=cart-drawer').then(function(r) { return r.text(); }),
      fetch('/?section_id=cart-icon-bubble').then(function(r) { return r.text(); })
    ]).then(function(results) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      drawer.classList.remove('is-empty');
      var parser = new DOMParser();
      var newDrawer = parser.parseFromString(results[0], 'text/html').querySelector('#CartDrawer');
      var newBubble = parser.parseFromString(results[1], 'text/html').querySelector('.shopify-section');
      if (newDrawer) {
        var el = document.getElementById('CartDrawer');
        if (el) el.innerHTML = newDrawer.innerHTML;
      }
      if (newBubble) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) bubble.innerHTML = newBubble.innerHTML;
      }
      var inner = drawer.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
    });
  }

  /* NEW badge pulse on scroll into view */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('wettr-pulse');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    function observeNewBadges() {
      document.querySelectorAll('.wettr-badge--new:not(.wettr-pulse)').forEach(function(badge) {
        observer.observe(badge);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeNewBadges);
    } else {
      observeNewBadges();
    }
    // Re-observe after dynamic content loads
    setTimeout(observeNewBadges, 2000);
  }
})();
